import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { SmsReminderEdit } from './forms/SmsReminderEdit.jsx';
import { SmsReminderPreview } from './forms/SmsReminderPreview.jsx';

class SmsReminders extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      minutes: this.props.minutes || '',
      reminders: this.props.reminders,
      others: this.props.others,
      nextId: this.props.others.length,
      error: '',
      preview: Boolean(this.props.minutes)
    };
    this.onReminderCheck = this.onReminderCheck.bind(this);
    this.onOtherCheck = this.onOtherCheck.bind(this);
    this.addOther = this.addOther.bind(this);
    this.removeOther = this.removeOther.bind(this);
    this.timeInput = this.timeInput.bind(this);
    this.mobileInput = this.mobileInput.bind(this);
    this.submitAction = this.submitAction.bind(this);
    this.editAction = this.editAction.bind(this);
  }

  onReminderCheck(e) {
    var reminders = this.state.reminders;
    const index = reminders.findIndex(x => x.user_id==e.target.id);
    reminders[index].selected = !reminders[index].selected;
    this.setState({reminders});
  }

  onOtherCheck(e) {
    var others = this.state.others;
    const index = others.findIndex(x => x.other_id==e.target.id);
    others[index].selected = !others[index].selected;
    this.setState({others});
  }

  addOther() {
    var others = this.state.others;
    var nextId = this.state.nextId + 1;
    others.push({
      other_id: 'Other' + nextId,
      category: 'Others',
      mobile: '',
      selected: true
    })
    this.setState({others, nextId});
  }

  removeOther(e) {
    var others = this.state.others;
    const index = others.findIndex(x => x.other_id==e.target.id);
    others.splice(index, 1);
    this.setState({others});
  }

  timeInput(e) {
    this.setState({ minutes: e.target.value });
  }

  mobileInput(e) {
    var others = this.state.others;
    const index = others.findIndex(x => x.other_id==e.target.id);
    others[index].mobile = e.target.value;
    this.setState({others});
  }

  submitAction() {
    if (this.state.minutes >= 10) {
      this.setState({ error: '' });
      axios.put('/api/v1/sms_reminders', {
        user_id: this.props.user_id,
        show_id: this.props.show_id,
        minutes: this.state.minutes,
        reminders: this.state.reminders,
        others: this.state.others,
      })
        .then(response => this.setState({ preview: true }))
        .catch(error => this.setState({ error: error.response.headers['error-message'] }))
    } else {
      this.setState({ error: 'Please enter the number of minutes, it has to be 10 or more.' })
    }
  }

  editAction() {
    this.setState({ preview: false })
  }

  maskMobile(mobile) {
    var parts = (mobile.replace('+1', '').replace(/\D/g, '')).match(/(\d{3})(\d{3})(\d{4})/);
    if (parts) {
      return '(' + parts[1] + ') ' + parts[2] + '-' + parts[3];
    } else {
      return '';
    }
  }

  render () {
    return (
      <div>
        <h3 className="text-center">In Gate Alert</h3>
        { this.state.preview ?
          <SmsReminderPreview
            minutes={this.state.minutes}
            reminders={this.state.reminders}
            others={this.state.others}
            editAction={this.editAction}
            maskMobile={this.maskMobile}
          /> :
          <SmsReminderEdit
            minutes={this.state.minutes}
            reminders={this.state.reminders}
            others={this.state.others}
            error={this.state.error}
            timeInput={this.timeInput}
            onReminderCheck={this.onReminderCheck}
            onOtherCheck={this.onOtherCheck}
            mobileInput={this.mobileInput}
            removeOther={this.removeOther}
            addOther={this.addOther}
            submitAction={this.submitAction}
            maskMobile={this.maskMobile}
          />
        }
      </div>
    );
  }
}

export default SmsReminders
